<template>
  <div
    v-if="variants.v1 === variant"
    class="pxp-header fixed-top pxp-animate"
    ref="header"
    :style="menuColors"
    style="background-color: var(--menu-background-color)"
    v-show="!isAnythingOnTopVisible"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="col-5 col-md-3 col-lg-2">
          <nuxt-link to="/" :external="true" class="pxp-logo text-decoration-none">
            <img
              :src="company.logo"
              loading="lazy"
              :alt="`${company.name} Logo`"
              style="width: auto; height: var(--logo-height)"
            />
          </nuxt-link>
        </div>
        <div class="col-2 col-md-7 col-lg-8 text-center">
          <ul class="pxp-nav list-inline" style="background-color: var(--menu-background-color-mobile)">
            <li
              v-for="(menuItem, groupIndex) in headerMenuItems"
              :key="`menuItemIndex-${groupIndex}`"
              class="list-inline-item"
            >
              <nuxt-link
                class="theme3-menu-link"
                :external="true"
                :to="menuItem.url"
                :target="menuItem.is_open_new_tab ? '_blank' : ''"
              >
                {{ menuItem.name }}</nuxt-link
              >
              <span
                v-if="menuItem.has_sub_menu"
                class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link"
                @click="toggleSubMenu(groupIndex)"
              ></span>
              <ul
                v-if="menuItem.sub_menus && menuItem.sub_menus.length && menuItem.has_sub_menu"
                class="pxp-nav-sub tw-rounded-sm"
                v-show="menuConfigs && menuConfigs[groupIndex] && menuConfigs[groupIndex].is_toggle_active"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuItem.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                >
                  <nuxt-link
                    class="theme3-sub-menu-link"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
            <li class="min-[1200px]:tw-hidden">
              <div class="tw-mt-5 tw-flex">
                <div>
                  <nc-button :is-link="true" link="/contact-us" :external="true" label="CONTACT US" :height="50">
                  </nc-button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-5 col-md-2" style="text-align: right">
          <a
            href="javascript:void(0);"
            class="pxp-header-nav-trigger"
            :style="`color: var(--mobile-hamburger-menu-color) !important; border-color: var(--mobile-hamburger-menu-color) !important`"
            ><span class="fa fa-bars"></span
          ></a>

          <div class="tw-hidden min-[1200px]:tw-inline-block">
            <nc-button :is-link="true" link="/contact-us" :external="true" label="CONTACT US" :height="50"> </nc-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="variants.v2 === variant"
    class="pxp-header fixed-top pxp-animate"
    ref="header"
    :style="menuColors"
    style="background-color: var(--menu-background-color)"
    v-show="!isAnythingOnTopVisible"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="col-5 col-md-3 col-lg-2">
          <nuxt-link to="/" :external="true" class="pxp-logo n-link text-decoration-none">
            <img
              :src="company.logo"
              loading="lazy"
              :alt="`${company.name} Logo`"
              style="width: auto; height: var(--logo-height)"
            />
          </nuxt-link>
        </div>
        <div class="col-2 col-md-7 col-lg-8 text-center">
          <ul
            class="pxp-nav list-inline tw-gap-x-2 xl:tw-flex xl:tw-flex-row xl:tw-items-center xl:tw-justify-center"
            style="background-color: var(--menu-background-color-mobile)"
          >
            <li
              v-for="(menuItem, groupIndex) in headerMenuItems"
              :key="`menuItemIndex-${groupIndex}`"
              class="list-inline-item xl:tw-flex xl:tw-flex-row xl:tw-flex-nowrap xl:tw-items-center xl:tw-justify-center"
            >
              <nuxt-link
                class="theme3-menu-link n-link !tw-uppercase"
                style="padding: 5px 10px 0px 5px !important"
                :external="true"
                :to="menuItem.url"
                :target="menuItem.is_open_new_tab ? '_blank' : ''"
              >
                {{ menuItem.name }}</nuxt-link
              >
              <span
                v-if="menuItem.has_sub_menu"
                class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link"
                @click="toggleSubMenu(groupIndex)"
              ></span>
              <ul
                v-if="menuItem.sub_menus && menuItem.sub_menus.length && menuItem.has_sub_menu"
                class="pxp-nav-sub tw-rounded-sm"
                v-show="menuConfigs && menuConfigs[groupIndex] && menuConfigs[groupIndex].is_toggle_active"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuItem.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                >
                  <nuxt-link
                    class="theme3-sub-menu-link n-link !tw-mt-3 tw-ml-5 tw-text-start"
                    :external="true"
                    :to="subMenu.url"
                    style="color: var(--c-primary) !important"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
            <li class="min-[1200px]:tw-hidden">
              <div class="tw-mt-10 tw-flex">
                <div>
                  <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
                    vars.buttonLabelText
                  }}</nuxt-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-5 col-md-2" style="text-align: right">
          <a
            href="javascript:void(0);"
            class="pxp-header-nav-trigger n-link !tw-rounded-full"
            :style="`color: var(--mobile-hamburger-menu-color) !important;padding: 10px !important; border-color: var(--mobile-hamburger-menu-color) !important; border: 1px solid var(--c-primary) !important`"
            ><span class="fa fa-bars"></span
          ></a>

          <div class="tw-hidden min-[1200px]:tw-inline-block">
            <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
              vars.buttonLabelText
            }}</nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="variants.v3 === variant"
    class="pxp-header fixed-top pxp-animate"
    ref="header"
    :style="menuColors"
    :class="`tw-bg-[var(--c-${vars.backgroundColor})]`"
    v-show="!isAnythingOnTopVisible"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="col-5 col-md-3 col-lg-2">
          <nuxt-link to="/" :external="true" class="pxp-logo n-link text-decoration-none">
            <img
              :src="company.logo"
              loading="lazy"
              :alt="`${company.name} Logo`"
              style="width: auto; height: var(--logo-height)"
            />
          </nuxt-link>
        </div>
        <div class="col-2 col-md-7 col-lg-8 text-center">
          <ul
            class="pxp-nav list-inline tw-gap-x-2 xl:tw-flex xl:tw-flex-row xl:tw-items-center xl:tw-justify-center"
            style="background-color: var(--menu-background-color-mobile)"
          >
            <li
              v-for="(menuItem, groupIndex) in headerMenuItems"
              :key="`menuItemIndex-${groupIndex}`"
              class="list-inline-item xl:tw-flex xl:tw-flex-row xl:tw-flex-nowrap xl:tw-items-center xl:tw-justify-center"
            >
              <nuxt-link
                class="theme3-menu-link n-link !tw-uppercase"
                style="padding: 5px 10px 0px 5px !important; margin-top: 15px"
                :external="true"
                :to="menuItem.url"
                :target="menuItem.is_open_new_tab ? '_blank' : ''"
                :class="{ active: isMenuItemActive(menuItem) }"
              >
                {{ menuItem.name }}</nuxt-link
              >
              <span
                v-if="menuItem.has_sub_menu"
                class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link"
                @click="toggleSubMenu(groupIndex)"
              ></span>
              <ul
                v-if="menuItem.sub_menus && menuItem.sub_menus.length && menuItem.has_sub_menu"
                class="pxp-nav-sub tw-rounded-sm"
                v-show="menuConfigs && menuConfigs[groupIndex] && menuConfigs[groupIndex].is_toggle_active"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuItem.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                >
                  <nuxt-link
                    class="theme3-sub-menu-link n-link !tw-mt-3 tw-ml-5 tw-text-start"
                    :external="true"
                    :to="subMenu.url"
                    style="color: var(--c-primary) !important"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
            <li class="min-[1200px]:tw-hidden">
              <div class="tw-mt-10 tw-flex">
                <div>
                  <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
                    vars.buttonLabelText
                  }}</nuxt-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-5 col-md-2" style="text-align: right">
          <a
            href="javascript:void(0);"
            class="pxp-header-nav-trigger n-link !tw-rounded-full"
            :style="`color: var(--mobile-hamburger-menu-color) !important;padding: 10px !important; border-color: var(--mobile-hamburger-menu-color) !important; border: 1px solid var(--c-primary) !important`"
            ><span class="fa fa-bars"></span
          ></a>

          <div class="tw-hidden min-[1200px]:tw-inline-block">
            <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
              vars.buttonLabelText
            }}</nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { RepoStates } from '~/units/core/types';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';
import { CompanyKeys } from '~/units/website/constants';

export default defineNuxtComponent({
  name: 'Theme3BaseHeaderOne',
  components: { NcButton },

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,

      menuConfigs: [],

      variants: {
        v1: 'HEADER_1',
        v2: 'HEADER_2',
        v3: 'HEADER_3',
      },
    };
  },

  created() {
    this.menuConfigs = this.headerMenu.map((i) => {
      return {
        is_toggle_active: false,
      };
    });
  },

  mounted() {
    $('.pxp-nav > li').hover(
      function () {
        var subMenu = $(this).children('ul:first');

        if (subMenu.length > 0 && !$('.pxp-header').hasClass('pxp-mobile')) {
          var subMenuWidth = subMenu.width();
          var menuItemLeft = $(this).offset().left;
          var windowWidth = $(window).width();
          var menuItemRight = windowWidth - menuItemLeft;

          if (menuItemRight < subMenuWidth) {
            subMenu.css({
              right: '0',
              left: 'auto',
            });
          }

          subMenu.fadeIn({ queue: false, duration: 200 });
          subMenu.animate({ top: '24px' }, 200);
        }
      },
      function () {
        var subMenu = $(this).children('ul:first');

        if (subMenu.length > 0 && !$('.pxp-header').hasClass('pxp-mobile')) {
          subMenu.fadeOut({ queue: false, duration: 200 });
          subMenu.animate({ top: '10px' }, 200);
        }
      },
    );

    this.updateFirstElementHeight();
    window.addEventListener('resize', this.updateFirstElementHeight);

    window.addEventListener('scroll', this.updateFirstElementHeight);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateFirstElementHeight);
    window.removeEventListener('scroll', this.updateFirstElementHeight);
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems', 'companyKey']),
    ...mapState(useCoreStore, ['headerHeight', 'isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems;
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    menuColors() {
      if (this.companyKey === CompanyKeys.BROWNS_ESTATE_AGENTS) {
        return {
          '--menu-item-color-mobile': this.colors?.white,
          '--menu-item-color': this.colors?.white,
          '--menu-item-color__hover': this.colors?.camel,

          '--sub-menu-item-color-mobile': this.colors?.white,
          '--sub-menu-item-color': this.colors?.raisin,

          '--mobile-hamburger-menu-color': this.colors?.white,

          '--menu-background-color': this.colors?.raisin,
          '--menu-background-color-mobile': this.colors?.raisin,

          '--menu-underline-color': this.colors?.camel,
          '--logo-height': '71px',
        };
      } else if (this.companyKey === CompanyKeys.JACKSONS_PROPERTY) {
        return {
          '--menu-item-color-mobile': this.colors?.primary,
          '--menu-item-color': this.colors?.primary,
          '--menu-item-color__hover': '#7F338F',

          '--sub-menu-item-color-mobile': this.colors?.white,
          '--sub-menu-item-color': this.colors?.raisin,

          '--mobile-hamburger-menu-color': '#7F338F',

          '--menu-background-color': '#fff',
          '--menu-background-color-mobile': '#fff',

          '--menu-underline-color': '#7F338F',
          '--logo-height': '52px',
        };
      } else if (this.companyKey === CompanyKeys.PROPERTY_CONNECTIONS) {
        return {
          '--menu-item-color-mobile': this.colors?.white,
          '--menu-item-color': this.colors?.white,
          '--menu-item-color__hover': this.colors?.primary,

          '--sub-menu-item-color-mobile': this.colors?.white,
          '--sub-menu-item-color': this.colors?.raisin,

          '--mobile-hamburger-menu-color': this.colors?.white,

          '--menu-background-color': this.colors?.secondary,
          '--menu-background-color-mobile': this.colors?.secondary,

          '--menu-underline-color': this.colors?.primary,
          '--logo-height': '52px',
        };
      } else {
        return {
          '--menu-item-color-mobile': '#808080',
          '--menu-item-color': '#808080',
          '--menu-item-color__hover': this.colors?.camel,

          '--sub-menu-item-color-mobile': '#808080',
          '--sub-menu-item-color': '#808080',

          '--mobile-hamburger-menu-color': '#808080',

          '--menu-background-color': this.colors?.raisin,
          '--menu-background-color-mobile': this.colors?.raisin,

          '--menu-underline-color': this.colors?.purple,

          '--logo-height': '52px',
        };
      }
    },
  },

  methods: {
    toggleSubMenu(index: number) {
      this.menuConfigs[index].is_toggle_active = !this.menuConfigs[index].is_toggle_active;
    },

    updateFirstElementHeight() {
      const coreStore = useCoreStore();
      const size = this.$refs?.header?.offsetHeight;
      coreStore.setHeaderHeight(size || 0);
    },

    normalizePath(url: string): string {
      if (!url) return '/';
      try {
        const abs = url.startsWith('http') ? new URL(url) : null;
        const path = abs ? abs.pathname : url.split('?')[0].split('#')[0];
        const cleaned = path.replace(/\/+$/, '');
        return cleaned.length ? cleaned : '/';
      } catch {
        const path = url.split('?')[0].split('#')[0];
        const cleaned = path.replace(/\/+$/, '');
        return cleaned.length ? cleaned : '/';
      }
    },

    isActiveUrl(url: string): boolean {
      if (!url || url.startsWith('http')) return false;
      const current = this.normalizePath(this.routeUrl);
      const target = this.normalizePath(url);
      return current === target || (current.startsWith(target + '/') && target !== '/');
    },

    isMenuItemActive(menuItem: any): boolean {
      if (!menuItem) return false;
      if (this.isActiveUrl(menuItem.url)) return true;
      if (Array.isArray(menuItem.sub_menus)) {
        return menuItem.sub_menus.some((sm: any) => this.isActiveUrl(sm?.url));
      }
      return false;
    },
  },
});
</script>

<style scoped>
.theme3-menu-link {
  color: var(--menu-item-color) !important;
}

.theme3-sub-menu-link {
  color: var(--sub-menu-item-color) !important;
}

.sub-menu-arrow {
  display: none;
  font-size: 14px;
  padding-left: 5px;
}

.pxp-nav > li > a:after {
  background-color: var(--menu-underline-color);
}

.pxp-nav > li > a:hover {
  color: var(--menu-item-color__hover) !important;
}

.theme3-sub-menu-link:hover ~ .pxp-nav > li > a {
  color: var(--menu-item-color__hover) !important;
}

@media only screen and (max-width: 1201px) {
  .theme3-menu-link {
    color: var(--menu-item-color-mobile) !important;
  }

  .theme3-sub-menu-link {
    color: var(--sub-menu-item-color-mobile) !important;
  }

  .sub-menu-arrow {
    display: inline-block;
  }
}

.pxp-header.pxp-mobile:after {
  content: unset !important;
}

.pxp-is-sticky .pxp-nav > li:hover > a:after,
.pxp-mobile .pxp-nav > li:hover > a:after {
  background-color: var(--menu-underline-color);
}

/* Active state styling for variant 3 (applies when .active is set) */
.pxp-nav > li > a.active {
  color: var(--menu-item-color__hover) !important;
}
.pxp-nav > li > a.active:after {
  width: 100%;
  opacity: 1;
  background-color: var(--menu-underline-color);
}
</style>
